import { useReveal } from "@/hooks/useReveal";

const LOGOS = [
  {
    name: "USDA Organic",
    src: "https://storage.helloreaddy.io/project_files/1d5eebb5-cdd6-4798-a44f-e501204aaa58/c1664af2-5ce1-4994-b13e-d3656dbecda9_compressed_usda-organics.webp",
  },
  {
    name: "EU Organic",
    src: "https://storage.helloreaddy.io/project_files/1d5eebb5-cdd6-4798-a44f-e501204aaa58/f1833692-a039-49c1-ad38-3094bff85b78_compressed_co-bio-154.webp",
  },
  {
    name: "Ecocert",
    src: "https://storage.helloreaddy.io/project_files/1d5eebb5-cdd6-4798-a44f-e501204aaa58/169216d4-bdf7-4fe8-b0a1-e3ec6cc8d9cb_compressed_eco-cert.webp",
  },
  {
    name: "Alimento Ecológico",
    src: "https://storage.helloreaddy.io/project_files/1d5eebb5-cdd6-4798-a44f-e501204aaa58/85351466-683c-4967-b076-cb23209f5770_compressed_alimento-ecologico.webp",
  },
  {
    name: "Colombia",
    src: "https://storage.helloreaddy.io/project_files/1d5eebb5-cdd6-4798-a44f-e501204aaa58/1b218246-42d3-4353-bf5b-ac99710e289b_compressed_co-brand.webp",
  },
];

export default function CertLogos() {
  const ref = useReveal<HTMLDivElement>();

  return (
    <section className="bg-white border-b border-cream-dark/40 py-10 md:py-12">
      <div ref={ref} className="max-w-[1200px] mx-auto px-4 md:px-6 reveal">
        <p className="text-center text-ink/60 text-sm font-medium uppercase tracking-[0.18em]">
          Our certifications
        </p>
        <div className="mt-6 flex flex-wrap items-center justify-center gap-x-6 md:gap-x-10 gap-y-6">
          {LOGOS.map((logo) => (
            <div
              key={logo.name}
              className="w-[100px] h-[72px] md:w-[120px] md:h-[84px] flex items-center justify-center"
              title={logo.name}
            >
              <img
                src={logo.src}
                alt={logo.name}
                className="max-w-full max-h-full object-contain"
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}